"use strict";
// Copyright 2019 ProximaX Limited. All rights reserved.
// Use of this source code is governed by the Apache 2.0
// license that can be found in the LICENSE file
Object.defineProperty(exports, "__esModule", { value: true });
const MetadataType_1 = require("./MetadataType");
const Convert_1 = require("../../core/format/Convert");
/**
 * MetadataEntry can be associated with an account/namespace/mosaic
 */
class MetadataEntry {
    /**
     * Constructor
     * @param version
     * @param compositeHash
     * @param sourceAddress
     * @param targetKey
     * @param scopedMetadataKey
     * @param targetId
     * @param metadataType
     * @param valueSize
     * @param value
     * @param id
     */
    constructor(version, compositeHash, sourceAddress, targetKey, scopedMetadataKey, targetId, metadataType, valueSize, value, id) {
        this.version = version;
        this.compositeHash = compositeHash;
        this.sourceAddress = sourceAddress;
        this.targetKey = targetKey;
        this.scopedMetadataKey = scopedMetadataKey;
        this.targetId = targetId;
        this.metadataType = metadataType;
        this.valueSize = valueSize;
        this.value = value;
        this.id = id;
        try {
            this.value = Convert_1.Convert.decodeHexToUtf8(value);
        }
        catch (error) {
            this.value = value;
        }
    }
    isAccountMetadata() {
        return this.metadataType === MetadataType_1.MetadataType.ACCOUNT;
    }
    isMosaicMetadata() {
        return this.metadataType === MetadataType_1.MetadataType.MOSAIC;
    }
    isNamespaceMetadata() {
        return this.metadataType === MetadataType_1.MetadataType.NAMESPACE;
    }
}
exports.MetadataEntry = MetadataEntry;
//# sourceMappingURL=MetadataEntry.js.map